import React, { useEffect, useState } from 'react';
import { Inspecao } from './Types';
import blogFetch from '../../axios/config';


export const TabelInspecos = () => {


    const [inspecoes, setInspecoes] = useState<Inspecao[]>([]);


  useEffect(() => {

    getInspecoes();

  }, []);

  const getInspecoes = async () => {
      try {
        const response = await blogFetch.get('ISAGA_InspecaoFinal/GetInspecaoFinal')

        setInspecoes(response.data);
      } catch (error) {
        console.log(error)
      }
  }


  return (
    <div className="card mb-2">
      <div className="card-header">
        <h2 className="card-title h6 mb-0">Consumo de Componentes</h2>
      </div>
      <div className="card-body p-0" style={{ maxHeight: '300px', overflowY: 'auto' }}>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-sm mb-0">
            <thead>
              <tr>
                <th>Lote</th>
                <th>Data_Criado</th>
                <th>Criado</th>
                <th>Status</th>
                <th>Data_Verificado</th>
                <th>Verificado</th>
              </tr>
            </thead>
            <tbody>
              {inspecoes.map((item, index) => (
                <tr key={index}>
                  <td>{item.inspecao_lote}</td>
                  <td>{new Date(item.data_criado).toLocaleDateString("pt-BR")}</td>
                  <td>{item.criadoPor}</td>
                  <td>{item.inpecao_status}</td>
                  <td>{item.data_verificado ? new Date(item.data_verificado).toLocaleDateString("pt-BR") : ""}</td>
                  <td>{item.verificado_por}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
